import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { ContentTemplate, TitleHeader } from 'web-library';
import ResitReceipt from '../../modules/resit/components/@coordinator/ResitReceipt';
import RouteKey from '../../routes/key';
import { parseLocationSearch } from '../../utils/StringUtils';
import ExamLevelKeyValue from './ExamLevelKeyValue';
import { useWOGAA } from '../../hooks/wogaa';


const { error: errorRoute } = RouteKey.child;

interface CoordinatorResitTransactionDetailProps {
  title: string;
  isHideExamLevel?: boolean;
}

interface CoordinatorTransactionDetailParams {
  internalTransactionRef: string;
}

const CoordinatorResitTransactionDetail = ({
  title = '',
  isHideExamLevel = false,
}: CoordinatorResitTransactionDetailProps) => {
  const history = useHistory();
  const { t } = useTranslation();

  const { transactionEnd } =  useWOGAA('myexamsseab-6475');

  const location = useLocation<CoordinatorTransactionDetailParams>();
  const { internalTransactionRef } = parseLocationSearch(location.search);

  /** WOGAA transaction tracking end for resit by coordinator
   * */
  transactionEnd(internalTransactionRef);

  useEffect(() => {
    if (!internalTransactionRef) {
      history.push(`/${errorRoute}`);
    }
  }, [history, internalTransactionRef]);

  return (
    <>
      <TitleHeader
        state="success"
        title={t(
          'resit->>ResitReceipt.Thank you. The registration for candidate(s) have been submitted.'
        )}
      />

      {!isHideExamLevel && <ExamLevelKeyValue />}

      <ContentTemplate>
        <ResitReceipt internalTransactionRef={internalTransactionRef || ''} />
      </ContentTemplate>
    </>
  );
};

export default CoordinatorResitTransactionDetail;
